import { useEffect } from 'react'

export function useMuiSsr(): void {
  // Remove the Material-Ui server-side injected CSS. On mount
  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side')
    jssStyles?.parentElement?.removeChild(jssStyles)
  }, [])
}
